"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../runtime/dom");
exports.ElementWrapper = dom_1.ElementWrapper;
exports.ComponentWrapper = dom_1.ComponentWrapper;
var awsui_alert_1 = require("./alert/awsui-alert");
exports.AlertWrapper = awsui_alert_1.default;
var awsui_app_layout_1 = require("./app-layout/awsui-app-layout");
exports.AppLayoutWrapper = awsui_app_layout_1.default;
var awsui_attribute_editor_1 = require("./attribute-editor/awsui-attribute-editor");
exports.AttributeEditorWrapper = awsui_attribute_editor_1.default;
var awsui_autosuggest_1 = require("./input/awsui-autosuggest");
exports.AutosuggestWrapper = awsui_autosuggest_1.default;
var awsui_breadcrumb_group_1 = require("./breadcrumbs/awsui-breadcrumb-group");
exports.BreadcrumbGroupWrapper = awsui_breadcrumb_group_1.default;
var awsui_button_dropdown_1 = require("./button/awsui-button-dropdown");
exports.ButtonDropdownWrapper = awsui_button_dropdown_1.default;
var awsui_button_1 = require("./button/awsui-button");
exports.ButtonWrapper = awsui_button_1.default;
var awsui_cards_content_selector_1 = require("./table/awsui-cards-content-selector");
exports.CardsContentSelectorWrapper = awsui_cards_content_selector_1.default;
var awsui_cards_filtering_1 = require("./table/awsui-cards-filtering");
exports.CardsFilteringWrapper = awsui_cards_filtering_1.default;
var awsui_cards_page_size_selector_1 = require("./table/awsui-cards-page-size-selector");
exports.CardsPageSizeSelectorWrapper = awsui_cards_page_size_selector_1.default;
var awsui_cards_pagination_1 = require("./table/awsui-cards-pagination");
exports.CardsPaginationWrapper = awsui_cards_pagination_1.default;
var awsui_cards_preferences_1 = require("./table/awsui-cards-preferences");
exports.CardsPreferencesWrapper = awsui_cards_preferences_1.default;
var awsui_cards_property_filtering_1 = require("./table/awsui-cards-property-filtering");
exports.CardsPropertyFilteringWrapper = awsui_cards_property_filtering_1.default;
var awsui_cards_1 = require("./cards/awsui-cards");
exports.CardsWrapper = awsui_cards_1.default;
var awsui_checkbox_1 = require("./checkbox/awsui-checkbox");
exports.CheckboxWrapper = awsui_checkbox_1.default;
var awsui_date_picker_1 = require("./date-picker/awsui-date-picker");
exports.DatePickerWrapper = awsui_date_picker_1.default;
var awsui_expandable_section_1 = require("./expandable-section/awsui-expandable-section");
exports.ExpandableSectionWrapper = awsui_expandable_section_1.default;
var awsui_flash_1 = require("./flash/awsui-flash");
exports.FlashWrapper = awsui_flash_1.default;
var awsui_flashbar_1 = require("./flash/awsui-flashbar");
exports.FlashbarWrapper = awsui_flashbar_1.default;
var awsui_form_field_1 = require("./form-field/awsui-form-field");
exports.FormFieldWrapper = awsui_form_field_1.default;
var awsui_form_section_1 = require("./form/awsui-form-section");
exports.FormSectionWrapper = awsui_form_section_1.default;
var awsui_form_1 = require("./form/awsui-form");
exports.FormWrapper = awsui_form_1.default;
var awsui_input_1 = require("./input/awsui-input");
exports.InputWrapper = awsui_input_1.default;
var awsui_modal_1 = require("./modal/awsui-modal");
exports.ModalWrapper = awsui_modal_1.default;
var awsui_multiselect_1 = require("./select/awsui-multiselect");
exports.MultiselectWrapper = awsui_multiselect_1.default;
var awsui_popover_1 = require("./popover/awsui-popover");
exports.PopoverWrapper = awsui_popover_1.default;
var awsui_progress_bar_1 = require("./progress-bar/awsui-progress-bar");
exports.ProgressBarWrapper = awsui_progress_bar_1.default;
var awsui_radio_button_1 = require("./radio/awsui-radio-button");
exports.RadioButtonWrapper = awsui_radio_button_1.default;
var awsui_radio_group_1 = require("./radio/awsui-radio-group");
exports.RadioGroupWrapper = awsui_radio_group_1.default;
var awsui_s3_resource_selector_1 = require("./s3-resource-selector/awsui-s3-resource-selector");
exports.S3ResourceSelectorWrapper = awsui_s3_resource_selector_1.default;
var awsui_segmented_control_1 = require("./segmented-control/awsui-segmented-control");
exports.SegmentedControlWrapper = awsui_segmented_control_1.default;
var awsui_select_1 = require("./select/awsui-select");
exports.SelectWrapper = awsui_select_1.default;
var awsui_side_navigation_1 = require("./side-navigation/awsui-side-navigation");
exports.SideNavigationWrapper = awsui_side_navigation_1.default;
var awsui_table_content_selector_1 = require("./table/awsui-table-content-selector");
exports.TableContentSelectorWrapper = awsui_table_content_selector_1.default;
var awsui_table_filtering_1 = require("./table/awsui-table-filtering");
exports.TableFilteringWrapper = awsui_table_filtering_1.default;
var awsui_table_page_size_selector_1 = require("./table/awsui-table-page-size-selector");
exports.TablePageSizeSelectorWrapper = awsui_table_page_size_selector_1.default;
var awsui_table_pagination_1 = require("./table/awsui-table-pagination");
exports.TablePaginationWrapper = awsui_table_pagination_1.default;
var awsui_table_preferences_1 = require("./table/awsui-table-preferences");
exports.TablePreferencesWrapper = awsui_table_preferences_1.default;
var awsui_table_property_filtering_1 = require("./table/awsui-table-property-filtering");
exports.TablePropertyFilteringWrapper = awsui_table_property_filtering_1.default;
var awsui_table_wrap_lines_1 = require("./table/awsui-table-wrap-lines");
exports.TableWrapLinesWrapper = awsui_table_wrap_lines_1.default;
var awsui_table_1 = require("./table/awsui-table");
exports.TableWrapper = awsui_table_1.default;
var awsui_tabs_1 = require("./tabs/awsui-tabs");
exports.TabsWrapper = awsui_tabs_1.default;
var awsui_tag_editor_1 = require("./tag-editor/awsui-tag-editor");
exports.TagEditorWrapper = awsui_tag_editor_1.default;
var awsui_textarea_1 = require("./textarea/awsui-textarea");
exports.TextareaWrapper = awsui_textarea_1.default;
var awsui_tiles_1 = require("./radio/awsui-tiles");
exports.TilesWrapper = awsui_tiles_1.default;
var awsui_time_input_1 = require("./time-input/awsui-time-input");
exports.TimeInputWrapper = awsui_time_input_1.default;
var awsui_toggle_1 = require("./checkbox/awsui-toggle");
exports.ToggleWrapper = awsui_toggle_1.default;
var awsui_token_group_1 = require("./token/awsui-token-group");
exports.TokenGroupWrapper = awsui_token_group_1.default;
var awsui_tooltip_1 = require("./tooltip/awsui-tooltip");
exports.TooltipWrapper = awsui_tooltip_1.default;
var awsui_wizard_1 = require("./wizard/awsui-wizard");
exports.WizardWrapper = awsui_wizard_1.default;
dom_1.ElementWrapper.prototype.findAlert = function (selector) {
    if (selector === void 0) { selector = 'awsui-alert'; }
    return this.findComponent(selector, awsui_alert_1.default);
};
dom_1.ElementWrapper.prototype.findAppLayout = function (selector) {
    if (selector === void 0) { selector = 'awsui-app-layout'; }
    return this.findComponent(selector, awsui_app_layout_1.default);
};
dom_1.ElementWrapper.prototype.findAttributeEditor = function (selector) {
    if (selector === void 0) { selector = 'awsui-attribute-editor'; }
    return this.findComponent(selector, awsui_attribute_editor_1.default);
};
dom_1.ElementWrapper.prototype.findAutosuggest = function (selector) {
    if (selector === void 0) { selector = 'awsui-autosuggest'; }
    return this.findComponent(selector, awsui_autosuggest_1.default);
};
dom_1.ElementWrapper.prototype.findBadge = function (selector) {
    if (selector === void 0) { selector = 'awsui-badge'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findBreadcrumbGroup = function (selector) {
    if (selector === void 0) { selector = 'awsui-breadcrumb-group'; }
    return this.findComponent(selector, awsui_breadcrumb_group_1.default);
};
dom_1.ElementWrapper.prototype.findBreadcrumbItem = function (selector) {
    if (selector === void 0) { selector = 'awsui-breadcrumb-item'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findButtonDropdown = function (selector) {
    if (selector === void 0) { selector = 'awsui-button-dropdown'; }
    return this.findComponent(selector, awsui_button_dropdown_1.default);
};
dom_1.ElementWrapper.prototype.findButton = function (selector) {
    if (selector === void 0) { selector = 'awsui-button'; }
    return this.findComponent(selector, awsui_button_1.default);
};
dom_1.ElementWrapper.prototype.findCardsContentSelector = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-content-selector'; }
    return this.findComponent(selector, awsui_cards_content_selector_1.default);
};
dom_1.ElementWrapper.prototype.findCardsFiltering = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-filtering'; }
    return this.findComponent(selector, awsui_cards_filtering_1.default);
};
dom_1.ElementWrapper.prototype.findCardsPageSizeSelector = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-page-size-selector'; }
    return this.findComponent(selector, awsui_cards_page_size_selector_1.default);
};
dom_1.ElementWrapper.prototype.findCardsPagination = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-pagination'; }
    return this.findComponent(selector, awsui_cards_pagination_1.default);
};
dom_1.ElementWrapper.prototype.findCardsPreferences = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-preferences'; }
    return this.findComponent(selector, awsui_cards_preferences_1.default);
};
dom_1.ElementWrapper.prototype.findCardsPropertyFiltering = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-property-filtering'; }
    return this.findComponent(selector, awsui_cards_property_filtering_1.default);
};
dom_1.ElementWrapper.prototype.findCardsSelection = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards-selection'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findCards = function (selector) {
    if (selector === void 0) { selector = 'awsui-cards'; }
    return this.findComponent(selector, awsui_cards_1.default);
};
dom_1.ElementWrapper.prototype.findCheckbox = function (selector) {
    if (selector === void 0) { selector = 'awsui-checkbox'; }
    return this.findComponent(selector, awsui_checkbox_1.default);
};
dom_1.ElementWrapper.prototype.findColumnLayout = function (selector) {
    if (selector === void 0) { selector = 'awsui-column-layout'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findDatePicker = function (selector) {
    if (selector === void 0) { selector = 'awsui-date-picker'; }
    return this.findComponent(selector, awsui_date_picker_1.default);
};
dom_1.ElementWrapper.prototype.findExpandableSection = function (selector) {
    if (selector === void 0) { selector = 'awsui-expandable-section'; }
    return this.findComponent(selector, awsui_expandable_section_1.default);
};
dom_1.ElementWrapper.prototype.findFlash = function (selector) {
    if (selector === void 0) { selector = 'awsui-flash'; }
    return this.findComponent(selector, awsui_flash_1.default);
};
dom_1.ElementWrapper.prototype.findFlashbar = function (selector) {
    if (selector === void 0) { selector = 'awsui-flashbar'; }
    return this.findComponent(selector, awsui_flashbar_1.default);
};
dom_1.ElementWrapper.prototype.findFormField = function (selector) {
    if (selector === void 0) { selector = 'awsui-form-field'; }
    return this.findComponent(selector, awsui_form_field_1.default);
};
dom_1.ElementWrapper.prototype.findFormSection = function (selector) {
    if (selector === void 0) { selector = 'awsui-form-section'; }
    return this.findComponent(selector, awsui_form_section_1.default);
};
dom_1.ElementWrapper.prototype.findForm = function (selector) {
    if (selector === void 0) { selector = 'awsui-form'; }
    return this.findComponent(selector, awsui_form_1.default);
};
dom_1.ElementWrapper.prototype.findIcon = function (selector) {
    if (selector === void 0) { selector = 'awsui-icon'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findInput = function (selector) {
    if (selector === void 0) { selector = 'awsui-input'; }
    return this.findComponent(selector, awsui_input_1.default);
};
dom_1.ElementWrapper.prototype.findModal = function (selector) {
    if (selector === void 0) { selector = 'awsui-modal'; }
    return this.findComponent(selector, awsui_modal_1.default);
};
dom_1.ElementWrapper.prototype.findMultiselect = function (selector) {
    if (selector === void 0) { selector = 'awsui-multiselect'; }
    return this.findComponent(selector, awsui_multiselect_1.default);
};
dom_1.ElementWrapper.prototype.findPopover = function (selector) {
    if (selector === void 0) { selector = 'awsui-popover'; }
    return this.findComponent(selector, awsui_popover_1.default);
};
dom_1.ElementWrapper.prototype.findProgressBar = function (selector) {
    if (selector === void 0) { selector = 'awsui-progress-bar'; }
    return this.findComponent(selector, awsui_progress_bar_1.default);
};
dom_1.ElementWrapper.prototype.findRadioButton = function (selector) {
    if (selector === void 0) { selector = 'awsui-radio-button'; }
    return this.findComponent(selector, awsui_radio_button_1.default);
};
dom_1.ElementWrapper.prototype.findRadioGroup = function (selector) {
    if (selector === void 0) { selector = 'awsui-radio-group'; }
    return this.findComponent(selector, awsui_radio_group_1.default);
};
dom_1.ElementWrapper.prototype.findS3ResourceSelector = function (selector) {
    if (selector === void 0) { selector = 'awsui-s3-resource-selector'; }
    return this.findComponent(selector, awsui_s3_resource_selector_1.default);
};
dom_1.ElementWrapper.prototype.findSegmentedControl = function (selector) {
    if (selector === void 0) { selector = 'awsui-segmented-control'; }
    return this.findComponent(selector, awsui_segmented_control_1.default);
};
dom_1.ElementWrapper.prototype.findSelect = function (selector) {
    if (selector === void 0) { selector = 'awsui-select'; }
    return this.findComponent(selector, awsui_select_1.default);
};
dom_1.ElementWrapper.prototype.findSideNavigation = function (selector) {
    if (selector === void 0) { selector = 'awsui-side-navigation'; }
    return this.findComponent(selector, awsui_side_navigation_1.default);
};
dom_1.ElementWrapper.prototype.findSpinner = function (selector) {
    if (selector === void 0) { selector = 'awsui-spinner'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findTableContentSelector = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-content-selector'; }
    return this.findComponent(selector, awsui_table_content_selector_1.default);
};
dom_1.ElementWrapper.prototype.findTableFiltering = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-filtering'; }
    return this.findComponent(selector, awsui_table_filtering_1.default);
};
dom_1.ElementWrapper.prototype.findTablePageSizeSelector = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-page-size-selector'; }
    return this.findComponent(selector, awsui_table_page_size_selector_1.default);
};
dom_1.ElementWrapper.prototype.findTablePagination = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-pagination'; }
    return this.findComponent(selector, awsui_table_pagination_1.default);
};
dom_1.ElementWrapper.prototype.findTablePreferences = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-preferences'; }
    return this.findComponent(selector, awsui_table_preferences_1.default);
};
dom_1.ElementWrapper.prototype.findTablePropertyFiltering = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-property-filtering'; }
    return this.findComponent(selector, awsui_table_property_filtering_1.default);
};
dom_1.ElementWrapper.prototype.findTableSelection = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-selection'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findTableSorting = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-sorting'; }
    return this.findComponent(selector, dom_1.ComponentWrapper);
};
dom_1.ElementWrapper.prototype.findTableWrapLines = function (selector) {
    if (selector === void 0) { selector = 'awsui-table-wrap-lines'; }
    return this.findComponent(selector, awsui_table_wrap_lines_1.default);
};
dom_1.ElementWrapper.prototype.findTable = function (selector) {
    if (selector === void 0) { selector = 'awsui-table'; }
    return this.findComponent(selector, awsui_table_1.default);
};
dom_1.ElementWrapper.prototype.findTabs = function (selector) {
    if (selector === void 0) { selector = 'awsui-tabs'; }
    return this.findComponent(selector, awsui_tabs_1.default);
};
dom_1.ElementWrapper.prototype.findTagEditor = function (selector) {
    if (selector === void 0) { selector = 'awsui-tag-editor'; }
    return this.findComponent(selector, awsui_tag_editor_1.default);
};
dom_1.ElementWrapper.prototype.findTextarea = function (selector) {
    if (selector === void 0) { selector = 'awsui-textarea'; }
    return this.findComponent(selector, awsui_textarea_1.default);
};
dom_1.ElementWrapper.prototype.findTiles = function (selector) {
    if (selector === void 0) { selector = 'awsui-tiles'; }
    return this.findComponent(selector, awsui_tiles_1.default);
};
dom_1.ElementWrapper.prototype.findTimeInput = function (selector) {
    if (selector === void 0) { selector = 'awsui-time-input'; }
    return this.findComponent(selector, awsui_time_input_1.default);
};
dom_1.ElementWrapper.prototype.findToggle = function (selector) {
    if (selector === void 0) { selector = 'awsui-toggle'; }
    return this.findComponent(selector, awsui_toggle_1.default);
};
dom_1.ElementWrapper.prototype.findTokenGroup = function (selector) {
    if (selector === void 0) { selector = 'awsui-token-group'; }
    return this.findComponent(selector, awsui_token_group_1.default);
};
dom_1.ElementWrapper.prototype.findTooltip = function (selector) {
    if (selector === void 0) { selector = 'awsui-tooltip'; }
    return this.findComponent(selector, awsui_tooltip_1.default);
};
dom_1.ElementWrapper.prototype.findWizard = function (selector) {
    if (selector === void 0) { selector = 'awsui-wizard'; }
    return this.findComponent(selector, awsui_wizard_1.default);
};
function wrapper(root) {
    if (root === void 0) { root = document.body; }
    return new dom_1.ElementWrapper(root);
}
exports.default = wrapper;
//# sourceMappingURL=index.js.map